









import { editFactory } from '@/main/pages';

import { store } from './store/edit';
import { NAME, PROrdersParts } from './constants';

export default editFactory(NAME, store).extend({
	data() {
		return {
			dependencies: {
				[PROrdersParts]: PROrdersParts,
			},
		};
	},
});
